import React from "react";

import { Card, CardHeader, CardTitle } from "../../../styles";
import { ObservedAt } from "../../../components/ObservedAt";
import { SectionContent } from "../SectionContent";
import { AdminSectionProps } from "./types";

export const AdminSection = <T,>({
  id,
  title,
  section,
  onRetry,
  children,
  testId,
}: AdminSectionProps<T>) => (
  <Card id={id} aria-label={title} data-testid={testId}>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      {section.state === "available" && (
        <ObservedAt observedAt={section.observedAt} />
      )}
    </CardHeader>
    <SectionContent sectionName={title} section={section} onRetry={onRetry}>
      {children}
    </SectionContent>
  </Card>
);
